@file:OptIn(InternalResourceApi::class)

package survivai.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/survivai.composeapp.generated.resources/"

internal val Res.font.NotoEmoji: FontResource by lazy {
      FontResource("font:NotoEmoji", setOf(
        ResourceItem(setOf(), "${MD}font/NotoEmoji.ttf", -1, -1),
      ))
    }

internal val Res.font.NotoEmojiColor: FontResource by lazy {
      FontResource("font:NotoEmojiColor", setOf(
        ResourceItem(setOf(), "${MD}font/NotoEmojiColor.ttf", -1, -1),
      ))
    }

internal val Res.font.NotoSansKR: FontResource by lazy {
      FontResource("font:NotoSansKR", setOf(
        ResourceItem(setOf(), "${MD}font/NotoSansKR.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("NotoEmoji", Res.font.NotoEmoji)
  map.put("NotoEmojiColor", Res.font.NotoEmojiColor)
  map.put("NotoSansKR", Res.font.NotoSansKR)
}
